<template lang="pug">
  .op-modal
    .op-modal__title
      h2.title Отклонить заявку
    .op-modal__body
      .form
        .form__elem
          .form-elem
            .form-elem__title 1. Укажите причину отказа
            .form-elem__body

              .form-elem-list
                .form-elem-list__item
                  label.input-item
                    .input-item__input
                      .radio
                        input.radio__input(
                          type="radio"
                          name="reason"
                          :checked="checked === '0'"
                          @change="onChangeRadio('0')"
                        )
                        .radio__icon
                    .input-item__body
                      .input-item__text Недействительные документы
                .form-elem-list__item
                  label.input-item
                    .input-item__input
                      label.radio
                        input.radio__input(
                          type="radio"
                          name="reason"
                          :checked="checked === '1'"
                          @change="onChangeRadio('1')"
                        )
                        .radio__icon
                    .input-item__body
                      .input-item__text Не прошла по рейтингу
                .form-elem-list__item
                  label.input-item
                    .input-item__input
                      .radio
                        input.radio__input(
                          type="radio"
                          name="reason"
                          :checked="checked === '2'"
                          @change="onChangeRadio('2')"
                        )
                        .radio__icon
                    .input-item__body
                      .input-item__text Другая причина
        .form__elem
          .form-elem(
            :class="{ 'form-elem_error': errors.docsError }"
          )
            .form-elem__title 2. Укажите, какие документы являются не действительными
            .form-elem__body
              textarea.textarea.textarea_full(
                :disabled="checked === '1' || checked === '2'"
                v-model="docsError"
                v-on:keyup="keymonitor"
              )
        .form__elem
          .form-elem(
            :class="{ 'form-elem_error': errors.failureError }"
          )
            .form-elem__title 3. Укажите причину отказа
            .form-elem__body
              textarea.textarea.textarea_full(
                :disabled="checked === '0' || checked === '1'"
                v-model="failureError"
                v-on:keyup="keymonitor"
              )
        .form__elem.form__elem_button
          .form-elem
            .form-elem__body
              button.button.button_paint-secondary.button_long(
                type="submit"
                @click="onSubmit()"
              )
                .button__text Отправить
            .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
</template>

<script>
export default {
  name: "OperatorReject",
  props: ["onSubmitModal", "onCloseModal"],
  data() {
    return {
      showErrorInfo: false,
      checked: "0",
      docsError: "",
      failureError: "",
      errors: {
        docsError: false,
        failureError: false
      }
    };
  },
  methods: {
    onChangeRadio(type) {
      this.checked = type;
      this.keymonitor();
    },
    keymonitor() {
      this.showErrorInfo = false;
      this.errors = {
        docsError: false,
        failureError: false
      };
    },
    onSubmit() {
      const data = {};
      if (this.checked === "0") {
        this.failureError = "";
        data.comment = this.docsError;
        if (this.docsError.length === 0) {
          this.showErrorInfo = true;
          this.errors.docsError = true;
          return;
        }
      }
      if (this.checked === "2") {
        data.comment = this.failureError;
        this.docsError = "";
        if (this.failureError.length === 0) {
          this.showErrorInfo = true;
          this.errors.failureError = true;
          return;
        }
      }
      if (this.checked === "1") {
        data.comment = "";
        this.failureError = "";
        this.docsError = "";
      }
      data.reject_type = this.checked;
      this.onCloseModal();
      this.onSubmitModal(data, 11);
    }
  }
};
</script>
